export default function (element, data) {
    let paginationItems = element.querySelectorAll(".item");
    let step = 1; // равен step из sliderBlock
    paginationItems[0].classList.add("active");

    paginationItems.forEach(el => {
        el.addEventListener("click", function() {
            window.dispatchEvent(new CustomEvent("paginationupdate", {detail: {step: el.dataset.index}}));

            paginationItems[step-1].classList.remove("active");
            step = el.dataset.index;

            el.classList.add("active");
        });
    });

    window.addEventListener("pagination", function(event) {
        paginationItems[event.detail.remove].classList.remove("active");
        paginationItems[event.detail.add].classList.add("active");
        step = parseInt(event.detail.add) + 1;
    })
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
